/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React from "react";
import { Link } from "react-router-dom";

interface ArrowProps {
  link: string;
}

export default function Arrow({ link }: ArrowProps) {
  return (
    <div className="row mt-3 justify-content-end">
      <div className="col-2 text-right">
        <Link to={link}>
          <button className="btn btn-light">
            <i className="fas fa-arrow-right"></i>
          </button>
        </Link>
      </div>
    </div>
  );
}
